<template functional>
  <span>
    {{ $options.methods.getFormattedDateTime(props) }}
  </span>
</template>

<script>
import { DateTime } from 'luxon'

export default {
  name: 'MiaDatatableDateTimeColumn',

  props: {
    row: {
      type: Object,
      default() {
        return {}
      }
    },

    column: {
      type: Object,
      default() {
        return {}
      }
    }
  },

  methods: {
    getFormattedDateTime({ row, column }) {
      let date

      if (column.meta !== undefined && column.meta.parseDate !== undefined && typeof column.meta.parseDate === 'function') {
        date = column.meta.parseDate(row[column.field])
      } else if (column.meta === undefined || column.meta.inputFormat === undefined) {
        date = DateTime.fromSQL(row[column.field])
      } else {
        date = DateTime.fromFormat(row[column.field], column.meta.inputFormat)
      }

      if (column.meta !== undefined && column.meta.formatDate !== undefined && typeof column.meta.formatDate === 'function') {
        return column.meta.formatDate(date)
      }

      if (column.meta === undefined || column.meta.displayFormat === undefined) {
        return date.toFormat('dd.MM.yyyy HH:mm')
      }

      return date.toFormat(typeof column.meta.displayFormat === 'function' ? column.meta.displayFormat(row) : column.meta.displayFormat)
    }
  }
}
</script>
